import queryString from 'query-string';
import {
	ACTUAL_BEFORE,
	CLOSE_PO,
	GET_ALL_MONITORING,
	GET_ALL_MONITORING_FILTER,
	GET_ALL_MONITORING_FILTER_CUSTOME,
	GET_DATA_LIST,
	GET_DATA_LIST_CONTRACT,
	GET_REPORT,
	GET_TOP_CAPEX,
	GET_TOP_CAPEX_DASHBOARD,
	GET_TOP_CAPEX_DASHBOARD_FILTER,
	GET_TOP_OPEX,
	GET_TOP_OPEX_DASHBOARD,
	GET_TOP_OPEX_DASHBOARD_FILTER,
	GET_VENDOR,
	SAVE_ACTUAL_ITEM,
	SAVE_RELOCATE,
	SAVE_RELOCATE_EXT,
	SEND_EMAIL_PO,
	GET_UCONTRACT_DEPARTMENTS,
} from '../../api/budget_monitor';

const state = {
	list: [],
	listCapex: [],
	monitoring: [],
	topOpex: [],
	topCapex: [],
	vendor: [],
	report: null,
	// mode: "",
	listContract: [],
	listUcontractDepartments: [],
};

const mutations = {
	SET_LIST_DATA: (states, payload) => {
		states.list = payload;
	},
	SET_LIST_DATA_CAPEX: (states, payload) => {
		states.listCapex = payload;
	},
	SET_MONITORING: (states, payload) => {
		states.monitoring = payload;
	},
	SET_REPORT: (states, payload) => {
		states.report = payload;
	},
	SET_VENDOR: (states, payload) => {
		let dataTemp = payload.data.data.map((e) => {
			return `${e.VENDORACCT} - ${e.NAME1}`;
		});
		states.vendor = dataTemp;
	},

	SET_TOP_OPEX: (states, payload) => {
		states.topOpex = payload;
	},
	SET_TOP_CAPEX: (states, payload) => {
		states.topCapex = payload;
	},
	SET_LIST_CONTRACT(state, payload) {
		state.listContract = payload;
	},
	SET_UCONTRACT_DEPARTMENTS(state, payload) {
		state.listUcontractDepartments = payload;
	},
};

const actions = {
	GET_LIST_MONITOR: async ({ commit }, query) => {
		if (query.type == 'opex') {
			const resp = await GET_DATA_LIST(query);
			const data = resp.data.data;
			commit('SET_LIST_DATA', data);
		} else {
			const resp = await GET_DATA_LIST(query);
			const data = resp.data.data;
			commit('SET_LIST_DATA_CAPEX', data);
		}
	},

	ACTUAL_BEFORE: async ({}, query) => {
		await ACTUAL_BEFORE(query);
	},
	SAVE_RELOCATE: async ({}, query) => {
		await SAVE_RELOCATE(query);
	},
	SAVE_RELOCATE_EXT: async ({}, query) => {
		await SAVE_RELOCATE_EXT(query);
	},
	SAVE_ACTUAL_ITEM: async ({}, query) => {
		await SAVE_ACTUAL_ITEM(query);
	},
	CLOSE_PO: async ({}, id) => {
		await CLOSE_PO(id);
	},
	GET_ALL_MONITORING: async ({ commit }) => {
		// query = queryString.stringify(query);
		const resp = await GET_ALL_MONITORING();
		const data = resp.data.data;
		commit('SET_MONITORING', data);
	},
	GET_REPORT: async ({ commit }, type) => {
		// query = queryString.stringify(query);
		const resp = await GET_REPORT(type);
		const data = resp;
		commit('SET_REPORT', data);
	},
	GET_VENDORS: async ({ commit }, type) => {
		const resp = await GET_VENDOR(type);
		const data = resp;
		commit('SET_VENDOR', data);
	},

	GET_TOP_OPEX: async ({ commit }) => {
		// query = queryString.stringify(query);
		const resp = await GET_TOP_OPEX();
		const data = resp.data.data;
		commit('SET_TOP_OPEX', data);
	},
	GET_TOP_CAPEX: async ({ commit }) => {
		// query = queryString.stringify(query);
		const resp = await GET_TOP_CAPEX();
		const data = resp.data.data;
		commit('SET_TOP_CAPEX', data);
	},
	SEND_EMAIL_PO: async ({}, query) => {
		await SEND_EMAIL_PO(query);
	},
	GET_DASHBOARD: async ({ commit }, query) => {
		let dataquery = queryString.stringify(query);
		const resp = await GET_ALL_MONITORING_FILTER(dataquery);
		const data = resp.data.data;
		commit('SET_MONITORING', data);
	},
	GET_DASHBOARD_FILTER: async ({ commit }, query) => {
		let dataquery = queryString.stringify(query);
		const resp = await GET_ALL_MONITORING_FILTER_CUSTOME(dataquery);
		const data = resp.data.data;
		commit('SET_MONITORING', data);
	},
	GET_TOP_OPEX_DASHBOARD: async ({ commit }, query) => {
		let dataquery = queryString.stringify(query);
		const resp = await GET_TOP_OPEX_DASHBOARD(dataquery);
		const data = resp.data.data;
		commit('SET_TOP_OPEX', data);
	},
	GET_TOP_OPEX_DASHBOARD_FILTER: async ({ commit }, query) => {
		let dataquery = queryString.stringify(query);
		const resp = await GET_TOP_OPEX_DASHBOARD_FILTER(dataquery);
		const data = resp.data.data;
		commit('SET_TOP_OPEX', data);
	},
	GET_TOP_CAPEX_DASHBOARD: async ({ commit }, query) => {
		let dataquery = queryString.stringify(query);
		const resp = await GET_TOP_CAPEX_DASHBOARD(dataquery);
		const data = resp.data.data;
		commit('SET_TOP_CAPEX', data);
	},
	GET_TOP_CAPEX_DASHBOARD_FILTER: async ({ commit }, query) => {
		let dataquery = queryString.stringify(query);
		const resp = await GET_TOP_CAPEX_DASHBOARD_FILTER(dataquery);
		const data = resp.data.data;
		commit('SET_TOP_CAPEX', data);
	},
	GET_LIST_CONTRACT: async ({ commit }, query) => {
		try {
			// const response = await GET_DATA_LIST_CONTRACT({
			//     id: 12,
			//     page: 1,
			//     pageSize: 100,
			// });
			const response = await GET_DATA_LIST_CONTRACT(query);

			const contracts = response.data.data.map((item) => ({
				id: item.id,
				label: item.contract_name, // untuk ditampilkan di v-select
			}));

			commit('SET_LIST_CONTRACT', contracts);
		} catch (error) {
			console.error('Failed to fetch contracts:', error);
		}
	},
	GET_USER_UCONTRACT_DEPARTMENTS: async ({ commit }) => {
		try {
			const response = await GET_UCONTRACT_DEPARTMENTS();
			const departments = response.data.data;
			commit('SET_UCONTRACT_DEPARTMENTS', departments);
		} catch (error) {
			console.error('Failed to fetch contracts departments:', error);
		}
	},
};

const getters = {
	listData: (states) => states.list,
	listDataCapex: (states) => states.listCapex,
	allMonitoring: (states) => states.monitoring,
	report: (states) => states.report,
	listVendor: (states) => states.vendor,
	topOpex: (states) => states.topOpex,
	topCapex: (states) => states.topCapex,
	listContract: (state) => state.listContract,
	listUcontractDepartments: (state) => state.listUcontractDepartments,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
